import { QuoteHeaderDetail } from "src/pages/Quote/QuoteHeaderDetail";
import { QuoteListing } from "src/pages/Quote/QuoteListing";
import { OpenQuoteListing } from "./OpenQuoteListing";
import QuoteDetail from "src/pages/QuoteDetail";
import { __remove, __set } from "src/store/axios_indicator";
import Constants from "src/support/Constants";
import Helper from "src/support/Helper";

class Common {
    static chain = {
        QuoteHeaderDetail: { param_value: 'QuoteHeaderDetail', element: QuoteHeaderDetail },
        QuoteListing: { param_value: 'QuoteListing', element: QuoteListing },
        OpenQuoteListing: { param_value: 'OpenQuoteListing', element: OpenQuoteListing },
        QuoteDetail: { param_value: 'QuoteDetail', element: QuoteDetail },
    };
    static param_key = '__c';
    static redux_key = 'Quote__Component__Loader';
    static default_component = Common.chain.OpenQuoteListing;


    static roundOne = (n, q) => {
        if (n > 0)
            return Math.ceil(n / q) * q;
        else if (n < 0)
            return Math.floor(n / q) * q;
        else
            return q;
    }

    static validateRegex = (term, expr) => {
        let re = new RegExp(expr);
        if (re.test(term)) {
            return true;
        }
        return false;
    }

    static validateDuplicateQty = async (field, qty1, qty2, qty3) => {
        if (field === 'quantity1' && ((qty2 && qty2 > 0 && qty1 === qty2) || (qty3 && qty3 > 0 && qty1 === qty3))) {
            return false;
        }
        else if (field === 'quantity2' && ((qty1 && qty1 > 0 && qty2 === qty1) || (qty3 && qty3 > 0 && qty2 === qty3))) {
            return false;
        }
        else if (field === 'quantity3' && ((qty1 && qty1 > 0 && qty3 === qty1) || (qty2 && qty2 > 0 && qty3 === qty2))) {
            return false;
        }
        else
            return true;
    }

    static validateMinCharacter = (value) => {
        const isValid = value.length < 3 ? false : true;
        return isValid;
    }

    static validateTargetUnitPrice = (value, expr) => {
        if (Helper.valueIsNotNull(value) === false) {
            return true;
        }
        return this.validateRegex(value, expr);
    }

    static validateQuantityRFQNew = (minQty, multQty, speedBoatVal, lowestPrice, selectedQty) => {
        
        let speedBoatMinQty = minQty
        if (lowestPrice > 0) {
            const sbQty = Math.round(speedBoatVal / lowestPrice);
            const qty = Common.roundOne(sbQty, multQty);
            const actualQty = minQty > qty ? minQty : qty;
            speedBoatMinQty = actualQty;
        }

        if (selectedQty) {
            if (selectedQty < speedBoatMinQty) {
                selectedQty = speedBoatMinQty;
            } else {
                if (multQty !== undefined && selectedQty % multQty !== 0) {
                    selectedQty = speedBoatMinQty;
                }
            }
            return selectedQty
        }
        return speedBoatMinQty;
    }

    static isCpnIsManual = (single_product, selectedCPN) => {
        if (single_product?.CustomerPartNumbers?.length > 0) {
            if (single_product?.CustomerPartNumbers.filter(e => e.CPN === selectedCPN).length > 0) {
                return false;
            }
            return true;
        }
        return true;
    }

    static setDefaultCpnType = (isCPNListExists, isForEdit, isManual, isTypeUpdate) => {
        if (isCPNListExists) {
            let _type = Constants.cpnTypes.CPN;
            if (isForEdit && isManual) {
                _type = Constants.cpnTypes.MPN;
            } else {
                if (isTypeUpdate && isManual) {
                    _type = Constants.cpnTypes.MPN
                } else if (isManual)
                    _type = Constants.cpnTypes.MPN;
            }
            return _type;
        }
        else {
            return Constants.cpnTypes.MPN;
        }
    }

}

export default Common;